import {
  GET_PROVIDER_LIST,
  GET_PROVIDER_LIST_SUCCESS,
  GET_PROVIDER_LIST_FAILURE,
} from 'store/providerList/providerListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const providerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_LIST:
      return { ...state, loading: true };
    case GET_PROVIDER_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PROVIDER_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default providerListReducer;
